import { Contact, Communication, LeadStatus } from '../types/crm'

// Helper to generate random dates
const randomDate = (start: Date, end: Date) => {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime()),
  )
}

// Sample first names
const firstNames = [
  'Sarah',
  'Michael',
  'Emily',
  'David',
  'Jessica',
  'Robert',
  'Amanda',
  'James',
  'Lisa',
  'Christopher',
  'Jennifer',
  'Daniel',
  'Michelle',
  'Matthew',
  'Ashley',
  'Andrew',
  'Stephanie',
  'Joshua',
  'Nicole',
  'Ryan',
  'Elizabeth',
  'Brian',
  'Lauren',
  'Kevin',
  'Megan',
  'Justin',
  'Rachel',
  'Brandon',
  'Samantha',
  'Tyler',
  'Hannah',
  'Jason',
  'Brittany',
  'Jonathan',
  'Taylor',
  'Nathan',
  'Amber',
  'Eric',
  'Danielle',
  'Kyle',
  'Rebecca',
  'Jacob',
  'Melissa',
  'Aaron',
  'Heather',
  'Adam',
  'Laura',
  'Zachary',
  'Kimberly',
  'Alexander',
]

// Sample last names
const lastNames = [
  'Johnson',
  'Chen',
  'Rodriguez',
  'Kim',
  'Martinez',
  'Thompson',
  'Lee',
  'Wilson',
  'Anderson',
  'Brown',
  'Davis',
  'Miller',
  'Garcia',
  'Williams',
  'Jones',
  'Smith',
  'Taylor',
  'Moore',
  'Jackson',
  'Martin',
  'White',
  'Harris',
  'Clark',
  'Lewis',
  'Walker',
  'Hall',
  'Allen',
  'Young',
  'King',
  'Wright',
  'Lopez',
  'Hill',
  'Scott',
  'Green',
  'Adams',
  'Baker',
  'Nelson',
  'Carter',
  'Mitchell',
  'Roberts',
  'Turner',
  'Phillips',
  'Campbell',
  'Parker',
  'Evans',
  'Edwards',
  'Collins',
  'Stewart',
  'Morris',
  'Rogers',
]

// Sample companies
const companies = [
  'TechStart Inc',
  'DataFlow Solutions',
  'CloudScale Systems',
  'Innovate Labs',
  'Growth Partners',
  'BuildRight Construction',
  'Precision Manufacturing',
  'Supply Chain Pro',
  'Retail Solutions Inc',
  'Tech Ventures LLC',
  'Digital Dynamics',
  'NextGen Software',
  'Quantum Analytics',
  'Apex Industries',
  'Summit Enterprises',
  'Velocity Systems',
  'Horizon Tech',
  'Pinnacle Group',
  'Fusion Corp',
  'Catalyst Solutions',
  'Momentum Partners',
  'Elevate Consulting',
  'Nexus Technologies',
  'Vanguard Systems',
  'Zenith Corporation',
]

// Generate contacts
const generateContacts = (): Contact[] => {
  const baseContacts: Contact[] = [
    // Original 10 contacts
    {
      id: 'contact-wf-1',
      company_id: 'wf',
      first_name: 'Sarah',
      last_name: 'Johnson',
      company: 'TechStart Inc',
      email_primary: 'sarah.johnson@techstart.com',
      phone_primary: '(415) 555-0123',
      status: 'lead',
      companies: [
        {
          company_name: 'TKDScore',
          last_purchase_date: null,
          lifetime_purchase: 0,
        },
      ],
      notes: 'Interested in enterprise plan. Follow up next week.',
      created_at: new Date('2024-01-15'),
      updated_at: new Date('2024-01-15'),
    },
    {
      id: 'contact-wf-2',
      company_id: 'wf',
      first_name: 'Michael',
      last_name: 'Chen',
      company: 'DataFlow Solutions',
      email_primary: 'mchen@dataflow.io',
      email_secondary: 'michael@personal.com',
      phone_primary: '(650) 555-0234',
      phone_secondary: '(650) 555-0235',
      status: 'contact',
      companies: [
        {
          company_name: 'Website Forge',
          last_purchase_date: new Date('2024-01-10'),
          lifetime_purchase: 2500.0,
        },
        {
          company_name: 'Magnus Software',
          last_purchase_date: new Date('2023-12-15'),
          lifetime_purchase: 1800.0,
        },
      ],
      notes: 'Sent proposal on 1/10. Waiting for decision.',
      created_at: new Date('2024-01-10'),
      updated_at: new Date('2024-01-18'),
    },
    {
      id: 'contact-wf-3',
      company_id: 'wf',
      first_name: 'Emily',
      last_name: 'Rodriguez',
      company: 'CloudScale Systems',
      email_primary: 'emily.r@cloudscale.com',
      phone_primary: '(408) 555-0345',
      status: 'customer',
      companies: [
        {
          company_name: 'TKDScore',
          last_purchase_date: new Date('2024-01-20'),
          lifetime_purchase: 15000.0,
        },
        {
          company_name: 'Website Forge',
          last_purchase_date: new Date('2024-01-18'),
          lifetime_purchase: 8500.0,
        },
        {
          company_name: 'Magnus Software',
          last_purchase_date: new Date('2023-12-01'),
          lifetime_purchase: 12000.0,
        },
      ],
      notes: 'Active customer since Dec 2023. Very satisfied.',
      created_at: new Date('2023-12-01'),
      updated_at: new Date('2024-01-20'),
    },
    {
      id: 'contact-wf-4',
      company_id: 'wf',
      first_name: 'David',
      last_name: 'Kim',
      company: 'Innovate Labs',
      email_primary: 'dkim@innovatelabs.com',
      phone_primary: '(925) 555-0456',
      status: 'lead',
      companies: [],
      notes: 'Met at conference. Interested in demo.',
      created_at: new Date('2024-01-22'),
      updated_at: new Date('2024-01-22'),
    },
    {
      id: 'contact-wf-5',
      company_id: 'wf',
      first_name: 'Jessica',
      last_name: 'Martinez',
      company: 'Growth Partners',
      email_primary: 'jmartinez@growthpartners.com',
      phone_primary: '(510) 555-0567',
      status: 'contact',
      companies: [
        {
          company_name: 'Merem Blasting',
          last_purchase_date: new Date('2024-01-12'),
          lifetime_purchase: 3200.0,
        },
      ],
      notes: 'Scheduled demo for next Tuesday.',
      created_at: new Date('2024-01-12'),
      updated_at: new Date('2024-01-19'),
    },
    {
      id: 'contact-acme-1',
      company_id: 'acme',
      first_name: 'Robert',
      last_name: 'Thompson',
      company: 'BuildRight Construction',
      email_primary: 'rthompson@buildright.com',
      phone_primary: '(916) 555-0678',
      status: 'customer',
      companies: [
        {
          company_name: 'Mission Impossible',
          last_purchase_date: new Date('2024-01-10'),
          lifetime_purchase: 25000.0,
        },
        {
          company_name: 'Merem Blasting',
          last_purchase_date: new Date('2023-11-20'),
          lifetime_purchase: 18500.0,
        },
      ],
      notes: 'Long-term customer. Renews annually.',
      created_at: new Date('2023-10-15'),
      updated_at: new Date('2024-01-10'),
    },
    {
      id: 'contact-acme-2',
      company_id: 'acme',
      first_name: 'Amanda',
      last_name: 'Lee',
      company: 'Precision Manufacturing',
      email_primary: 'alee@precisionmfg.com',
      email_secondary: 'amanda.lee@gmail.com',
      phone_primary: '(209) 555-0789',
      status: 'lead',
      companies: [],
      notes: 'Requested pricing information.',
      created_at: new Date('2024-01-20'),
      updated_at: new Date('2024-01-20'),
    },
    {
      id: 'contact-acme-3',
      company_id: 'acme',
      first_name: 'James',
      last_name: 'Wilson',
      company: 'Supply Chain Pro',
      email_primary: 'jwilson@supplychainpro.com',
      phone_primary: '(559) 555-0890',
      phone_secondary: '(559) 555-0891',
      status: 'contact',
      companies: [
        {
          company_name: 'TKDScore',
          last_purchase_date: new Date('2024-01-05'),
          lifetime_purchase: 4500.0,
        },
      ],
      notes: 'In contract negotiation phase.',
      created_at: new Date('2024-01-05'),
      updated_at: new Date('2024-01-18'),
    },
    {
      id: 'contact-acme-4',
      company_id: 'acme',
      first_name: 'Lisa',
      last_name: 'Anderson',
      company: 'Retail Solutions Inc',
      email_primary: 'landerson@retailsolutions.com',
      phone_primary: '(831) 555-0901',
      status: 'customer',
      companies: [
        {
          company_name: 'Website Forge',
          last_purchase_date: new Date('2024-01-15'),
          lifetime_purchase: 9800.0,
        },
        {
          company_name: 'Magnus Software',
          last_purchase_date: new Date('2023-12-20'),
          lifetime_purchase: 7200.0,
        },
      ],
      notes: 'Upgraded to premium plan last month.',
      created_at: new Date('2023-11-20'),
      updated_at: new Date('2024-01-15'),
    },
    {
      id: 'contact-acme-5',
      company_id: 'acme',
      first_name: 'Christopher',
      last_name: 'Brown',
      company: 'Tech Ventures LLC',
      email_primary: 'cbrown@techventures.com',
      phone_primary: '(707) 555-1012',
      status: 'lost',
      companies: [],
      notes: 'Went with competitor. Price was main concern.',
      created_at: new Date('2024-01-23'),
      updated_at: new Date('2024-01-23'),
    },
  ]

  // Generate 50 additional contacts
  const statuses: LeadStatus[] = ['lead', 'contact', 'customer', 'lost']
  const companyIds = ['wf', 'acme']
  const productCompanies: Array<
    | 'TKDScore'
    | 'Website Forge'
    | 'Magnus Software'
    | 'Merem Blasting'
    | 'Mission Impossible'
  > = [
    'TKDScore',
    'Website Forge',
    'Magnus Software',
    'Merem Blasting',
    'Mission Impossible',
  ]

  for (let i = 0; i < 50; i++) {
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)]
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)]
    const company = companies[Math.floor(Math.random() * companies.length)]
    const status = statuses[Math.floor(Math.random() * statuses.length)]
    const companyId = companyIds[Math.floor(Math.random() * companyIds.length)]

    const email = `${firstName.toLowerCase()}.${lastName.toLowerCase()}@${company.toLowerCase().replace(/\s+/g, '')}.com`
    const phone = `(${Math.floor(Math.random() * 900) + 100}) 555-${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`

    // Generate company relationships based on status
    const companyRelationships = []
    if (status === 'customer') {
      // Customers have 1-3 company relationships
      const numRelationships = Math.floor(Math.random() * 3) + 1
      for (let j = 0; j < numRelationships; j++) {
        const productCompany =
          productCompanies[Math.floor(Math.random() * productCompanies.length)]
        if (
          !companyRelationships.find((r) => r.company_name === productCompany)
        ) {
          companyRelationships.push({
            company_name: productCompany,
            last_purchase_date: randomDate(
              new Date('2023-10-01'),
              new Date('2024-01-25'),
            ),
            lifetime_purchase: Math.floor(Math.random() * 50000) + 1000,
          })
        }
      }
    } else if (status === 'contact' && Math.random() > 0.5) {
      // Some contacts have 1 relationship
      const productCompany =
        productCompanies[Math.floor(Math.random() * productCompanies.length)]
      companyRelationships.push({
        company_name: productCompany,
        last_purchase_date: randomDate(
          new Date('2023-11-01'),
          new Date('2024-01-25'),
        ),
        lifetime_purchase: Math.floor(Math.random() * 10000) + 500,
      })
    }

    const createdDate = randomDate(
      new Date('2023-09-01'),
      new Date('2024-01-25'),
    )

    baseContacts.push({
      id: `contact-gen-${i}`,
      company_id: companyId,
      first_name: firstName,
      last_name: lastName,
      company,
      email_primary: email,
      phone_primary: phone,
      status,
      companies: companyRelationships,
      notes: '',
      created_at: createdDate,
      updated_at: createdDate,
    })
  }

  return baseContacts
}

export const contacts: Contact[] = generateContacts()

export const communications: Communication[] = [
  // Sarah Johnson communications
  {
    id: 'comm-1',
    contact_id: 'contact-wf-1',
    type: 'email',
    direction: 'outbound',
    subject: 'Enterprise Plan Information',
    content:
      'Hi Sarah, Thank you for your interest in our enterprise plan. I wanted to follow up...',
    timestamp: new Date('2024-01-16T10:30:00'),
  },
  {
    id: 'comm-2',
    contact_id: 'contact-wf-1',
    type: 'call',
    direction: 'inbound',
    content: 'Sarah called asking about pricing and implementation timeline',
    duration_minutes: 15,
    timestamp: new Date('2024-01-17T14:20:00'),
  },

  // Michael Chen communications
  {
    id: 'comm-3',
    contact_id: 'contact-wf-2',
    type: 'email',
    direction: 'inbound',
    subject: 'Re: Proposal Questions',
    content:
      'Thanks for the proposal. I have a few questions about the implementation...',
    timestamp: new Date('2024-01-11T09:15:00'),
  },
  {
    id: 'comm-4',
    contact_id: 'contact-wf-2',
    type: 'call',
    direction: 'outbound',
    content: 'Follow-up call to discuss proposal details and answer questions',
    duration_minutes: 25,
    timestamp: new Date('2024-01-12T11:00:00'),
  },
  {
    id: 'comm-5',
    contact_id: 'contact-wf-2',
    type: 'message',
    direction: 'inbound',
    content: 'Quick question - do you support SSO integration?',
    timestamp: new Date('2024-01-18T16:45:00'),
  },
  {
    id: 'comm-6',
    contact_id: 'contact-wf-2',
    type: 'message',
    direction: 'outbound',
    content:
      'Yes! We support SAML and OAuth SSO. Would you like to schedule a demo?',
    timestamp: new Date('2024-01-18T16:52:00'),
  },

  // Emily Rodriguez communications
  {
    id: 'comm-7',
    contact_id: 'contact-wf-3',
    type: 'email',
    direction: 'inbound',
    subject: 'Feature Request',
    content:
      'Hi team, We love the product! Would it be possible to add bulk export functionality?',
    timestamp: new Date('2024-01-19T13:30:00'),
  },
  {
    id: 'comm-8',
    contact_id: 'contact-wf-3',
    type: 'call',
    direction: 'outbound',
    content:
      'Quarterly check-in call. Emily very happy with service, mentioned feature request.',
    duration_minutes: 20,
    timestamp: new Date('2024-01-20T10:00:00'),
  },
  {
    id: 'comm-9',
    contact_id: 'contact-wf-3',
    type: 'email',
    direction: 'outbound',
    subject: 'Re: Feature Request',
    content:
      "Great news! Bulk export is on our roadmap for Q2. I'll keep you updated.",
    timestamp: new Date('2024-01-20T15:20:00'),
  },

  // David Kim communications
  {
    id: 'comm-10',
    contact_id: 'contact-wf-4',
    type: 'message',
    direction: 'inbound',
    content:
      'Hi! We met at TechConf. Can you send me more info about your platform?',
    timestamp: new Date('2024-01-22T18:30:00'),
  },
  {
    id: 'comm-11',
    contact_id: 'contact-wf-4',
    type: 'email',
    direction: 'outbound',
    subject: 'Great meeting you at TechConf!',
    content:
      "Hi David, It was great meeting you yesterday. Here's the information you requested...",
    timestamp: new Date('2024-01-23T09:00:00'),
  },

  // Robert Thompson communications
  {
    id: 'comm-12',
    contact_id: 'contact-acme-1',
    type: 'call',
    direction: 'inbound',
    content:
      'Robert called about renewal. Confirmed annual renewal, very satisfied.',
    duration_minutes: 12,
    timestamp: new Date('2024-01-08T14:00:00'),
  },
  {
    id: 'comm-13',
    contact_id: 'contact-acme-1',
    type: 'email',
    direction: 'outbound',
    subject: 'Renewal Confirmation',
    content:
      'Hi Robert, Thank you for renewing! Your new contract is attached.',
    timestamp: new Date('2024-01-10T11:30:00'),
  },
]
